import { FarmIcon, J1DownarrowA } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Stack, Typography, Box } from '@mui/material'
import { isUndefined } from 'lodash'
import React, { useCallback } from 'react'
import { useFarmContext } from 'src/Elements/Farm'
import useModals from 'src/Hooks/useModals'
import { useActiveInstallationContext } from 'src/Libs/installations'
import { getEmsProductImage } from 'src/Libs/installations/utils/product-image'

const STORAGE_ICON_HEIGHT = 24
const STORAGE_ICON_WIDTH = STORAGE_ICON_HEIGHT
const FARM_ICON_HEIGHT = 24
const FARM_ICON_WIDTH = 24
interface Props {
  isFarmAndClientsAllowedPage: boolean
  isOnlyFarmAllowedPage: boolean
  activeStorage?: string
}

/**
 * A component to open farm client selector modal. This component should be displayed
 * on the portal header
 */
const FarmSelector: React.FC<Props> = ({ activeStorage, isFarmAndClientsAllowedPage, isOnlyFarmAllowedPage }) => {
  const { openFarmParticipantSelector } = useModals()
  const { installation } = useActiveInstallationContext()
  const { t } = useCustomTranslation()
  const { isFarm, isFarmMasterSelected, farmClients, isError } = useFarmContext()

  const handleSelect = useCallback(() => {
    if (isUndefined(activeStorage)) return

    openFarmParticipantSelector({ selectedOptionStorageId: activeStorage })
  }, [activeStorage, openFarmParticipantSelector])

  if (!isFarm || isUndefined(activeStorage) || isError) return null

  const productType = farmClients?.find(client => client.storageId === activeStorage)?.productType
  const image = getEmsProductImage(productType, installation?.installationStatus, '2D')
  if (!isFarmAndClientsAllowedPage && !isOnlyFarmAllowedPage) return null

  return (
    <Stack
      sx={{ '@media (hover: hover)': { cursor: 'pointer' } }}
      onClick={() => handleSelect()}
      direction="row"
      spacing={1}
      justifyContent="center"
      alignItems="center"
      data-qa={'farm-selector'}
    >
      {isFarmMasterSelected ? (
        <Box sx={{ width: FARM_ICON_WIDTH, height: FARM_ICON_HEIGHT }}>
          <FarmIcon />
        </Box>
      ) : (
        <img height={STORAGE_ICON_HEIGHT} width={STORAGE_ICON_WIDTH} src={image} alt="farm-storage-icon" style={{ display: 'block' }} />
      )}
      <Typography variant="h2">{t('framework.installation.serialnumberShort', { serialnumber: activeStorage })}</Typography>
      <J1DownarrowA color={'primary'} />
    </Stack>
  )
}

export default FarmSelector
